// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Spog","badges":"styles_badges__yrGil"};